/* eslint-disable no-else-return */
import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Button } from 'reactstrap'
import FormattedMessage from '../FormattedMessage/FormattedMessage'
import ActivationKeyExpiration from './ActivationKeyExpiration'

import './ActivationKey.scss'

const ActivationKey = ({
  activationKey,
  staticKey,
  expiryDate,
  showLabel = true,
  handleReveal = () => {},
}) => {
  const [keyRevealed, setKeyRevealed] = useState(false)
  const [copied, setCopied] = useState(false)

  const handleRevealKey = () => {
    setKeyRevealed(!keyRevealed)
    if (typeof handleReveal === 'function') {
      handleReveal()
    }
  }

  const handleCopy = () => {
    setCopied(true)
  }

  const renderKey = key => {
    if (!keyRevealed) {
      return (
        <div>
          <Button
            color="dark"
            block
            outline
            onClick={handleRevealKey}
            aria-expanded="false"
            aria-controls="activation-key-content"
            aria-describedby="activation-key-label"
          >
            <FormattedMessage id="global.label.clickToView" />
          </Button>
        </div>
      )
    }

    return (
      <div
        className="py-2 px-5 reveal-key-container"
        id="activation-key-content"
        role="region"
        aria-live="polite"
        aria-label="Activation key revealed"
      >
        <CopyToClipboard onCopy={handleCopy} text={`${key}`}>
          {copied ? (
            <Button color="dark" outline aria-label="Activation key copied to clipboard" disabled>
              <FormattedMessage id="global.label.copied" />
            </Button>
          ) : (
            <Button color="dark" outline aria-label="Copy activation key to clipboard">
              <FormattedMessage id="global.label.copy" />
            </Button>
          )}
        </CopyToClipboard>{' '}
        <span className="activation-key-value" aria-label="Activation key value">
          {key}
        </span>
      </div>
    )
  }

  if (!activationKey) {
    return (
      <div role="status" aria-live="polite">
        <FormattedMessage id="global.label.noKey" />
      </div>
    )
  } else if (activationKey && staticKey) {
    return (
      <div role="region" aria-labelledby="activation-key-label">
        {showLabel && <ActivationKeyExpiration expiryDate={expiryDate} />}
        <div className="justify-content-between">
          <h6 className="d-inline-block mb-0 py-2 activation-key-label" id="activation-key-label">
            <FormattedMessage id="global.label.activationKey" />
          </h6>
          <div>{renderKey(staticKey)}</div>
        </div>
      </div>
    )
  } else if (activationKey && !staticKey) {
    return (
      <div role="region" aria-labelledby={showLabel ? 'activation-key-label' : undefined}>
        {showLabel && <ActivationKeyExpiration expiryDate={expiryDate} />}
        <div className="justify-content-between">
          {showLabel && (
            <h6 className="d-inline-block mb-0 py-2 activation-key-label" id="activation-key-label">
              <FormattedMessage id="global.label.activationKey" />
            </h6>
          )}
          <div>{renderKey(activationKey)}</div>
        </div>
      </div>
    )
  }

  return null
}

export default ActivationKey
